var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMailForOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.258,
    height: 73.723,
    viewBox: "0 0 44.258 73.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26798",
    "data-name": "Group 26798",
    transform: "translate(0.949 0.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26796",
    "data-name": "Group 26796",
    transform: "translate(12 20.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4577",
    "data-name": "Group 4577",
    transform: "translate(9.385 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24177",
    "data-name": "Path 24177",
    d: "M246.074,324.394c0,3.184,3.682,9.43,5.764,9.43,1.9,0,5.764-6.246,5.764-9.43a5.764,5.764,0,1,0-11.528,0Z",
    transform: "translate(-246.074 -318.63)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.703
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_592",
    "data-name": "Ellipse 592",
    cx: 1.968,
    cy: 1.968,
    rx: 1.968,
    ry: 1.968,
    transform: "translate(3.796 3.835)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.703
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4578",
    "data-name": "Group 4578",
    transform: "translate(0 9.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24178",
    "data-name": "Path 24178",
    d: "M240.109,335.946H230.63a.967.967,0,0,0-1.047.872v18.29a.781.781,0,0,0,.126.417,1.09,1.09,0,0,0,.921.455h28.206a1.127,1.127,0,0,0,.853-.368.773.773,0,0,0,.194-.5v-18.29a.973.973,0,0,0-1.047-.872h-9.519",
    transform: "translate(-229.583 -335.946)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.703
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24179",
    "data-name": "Path 24179",
    d: "M259.8,336.69l-13.727,9.968a1.426,1.426,0,0,1-1.686-.007l-13.6-10.057",
    transform: "translate(-230.187 -336.225)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.703
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_889",
    "data-name": "Line 889",
    x2: 8.326,
    y2: 8.326,
    transform: "translate(21.779 11.343)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.703
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_890",
    "data-name": "Line 890",
    y1: 8.239,
    x2: 8.229,
    transform: "translate(0.125 11.343)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.703
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26797",
    "data-name": "Group 26797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mina_produkter",
    "data-name": "Mina produkter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26735",
    "data-name": "Group 26735",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26658",
    "data-name": "Group 26658",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37303",
    "data-name": "Path 37303",
    d: "M36.916,19.879V-6.559A4.515,4.515,0,0,0,32.4-11.074H4.321A4.513,4.513,0,0,0-.191-6.559v62.8a4.513,4.513,0,0,0,4.513,4.513H32.4a4.514,4.514,0,0,0,4.513-4.513V38.954",
    transform: "translate(0.191 11.074)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26659",
    "data-name": "Group 26659",
    transform: "translate(9.94 66.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37304",
    "data-name": "Path 37304",
    d: "M17.229,0H0",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27300",
    "data-name": "Group 27300",
    transform: "translate(13.358 4.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26660",
    "data-name": "Group 26660",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37305",
    "data-name": "Path 37305",
    d: "M0,0H6.957",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26661",
    "data-name": "Group 26661",
    transform: "translate(10.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37306",
    "data-name": "Path 37306",
    d: "M0,0H.14",
    transform: "translate(0)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailForOrders);
export default __webpack_public_path__ + "static/media/Icon_mailForOrders.094df23d1b62821b93cc145e21344527.svg";
export { ForwardRef as ReactComponent };